<div fxLayout="column" class="heading">
    <span class="width">Badges & Awards Store</span>
    <p class="width">
        Customize your profile and showcase your interests by purchasing badges.
    </p>
</div>

<div class="main-div width" fxLayout="column">
    <div class="my-badges" fxLayoutGap="grid">
        <span class="title">My Badges & Awards</span>
        <p class="description">A preview of how your badges and awards appear on your profile:</p>
        <div class="mybadge" fxLayout="row wrap" fxLayoutGap="10px" style="justify-content: center;">
            <div *ngFor="let badge of allBadges" class="badge-resp" fxFlex="18" fxFlex.lt-md="25"
                fxFlex.xs="40" fxFlex.xl="15" fxLayout="column">
                <img src="{{badge.badgeurl}}" class="badge" alt="badge">
                <p class="award_name">{{badge.badgename}}</p>
            </div>
        </div>
    </div>

    <div class="status-badges">
        <span class="title">Status Badges</span>
        <p class="description">Earn more Creatics Currency and upgrade your status by unlocking
            and buying new badges. These badges will be showcased on your
            public profile, similar to stars on a coat. To unlock badges, you need a
            certain amount of Creatics Currency, making you eligible to purchase
            them using your currency.</p>
        <div class="badge-container" fxLayout="row wrap" fxLayoutGap="10px">
            <div *ngFor="let item of statusBadges; let i = index" (click)="openDialog(item,i)" 
            [ngClass]="{'remainBlur': i > 0 && !isFirstItemEarned}"  class="badge-resp" fxFlex="18" fxFlex.lt-md="25"
                fxFlex.xs="40" fxFlex.xl="15" fxLayout="column">
                <img [ngClass]="{'imgCursor': i > 0 && !isFirstItemEarned}" src="{{item.badgeurl}}" class="badge" alt="badge">
                <p class="award_name">{{item.badgename}}</p>
            </div>
        </div>
    </div>

    <div class="eco-badges">
        <span class="title">Ecosystem Badges</span>
        <p class="description">Showcase your identity as a Creator in a space or a Fan’s love of that space by
            purchasing ecosystem badges. Please use your Creatics currency or a debit/credit card for the purchase.
            Purchased badges appear in the 'Awards & Badges' section in your profile.</p>
        <div class="ecobadge-container" fxLayout="row wrap" fxLayoutGap="10px">
            <div *ngFor="let badge of showEcoBadges" class="ecobadges" style="justify-content: center;" fxFlex="18"
                fxFlex.lt-md="25" fxFlex.xs="40" fxFlex.xl="15" fxLayout="column" (click)="openDialogEco(badge)">
                <div>
                    <img src="{{badge.badgeurl}}" class="badge" alt="badge">
                    <p class="award_name eco-p">{{badge.badgename}}</p>
                </div>
            </div>
        </div>
        <div *ngIf="showMoreButton || showLessButtonVisible">
            <button class="show-more-button" *ngIf="showMoreButton" (click)="showMore()">
                <a>Show More</a>
            </button>
            <button class="show-less-button" *ngIf="showLessButtonVisible" (click)="showLess()">
                <a>Show Less</a>
            </button>
        </div>
    </div>
</div>

<!-- ------------------popup for status badge------------------------------ -->
<ng-template #dialogTemplate let-dialogRef="dialogRef" let-data>
    <div class="modal-header">
        <h4 class="modal-title eligible" id="modal-basic-title" *ngIf="!disable">Not Eligible!</h4>
        <h4 class="modal-title" id="modal-basic-title" *ngIf="disable">Upgrade yourself to {{data.name}}</h4>
    </div>
    <div style="justify-content: flex-end;" fxLayout="row">
        <button type="button" class="close-icon" aria-label="Close" (click)="dialogRef.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="custom-dialog-container" fxLayout="column">
        <img src="{{ data.image }}" class="badge popup-img" alt="badge">
        <p class="details" *ngIf="!disable">
            You cannot purchase this badge yet! You still need {{data.remainingCurrency}} creatics
            currency to be eligible to buy this badge.Keep interacting with the
            platform to purchase these badges.
        </p>
        <p class="available" *ngIf="!disable">Available Creatics Currency : {{currency}}</p>

        <p class="details" *ngIf="disable">
            <!-- Minimum Amount of Currency needed to earn the badge : {{data.amount}}<br><br> -->
            Buy this badge for {{data.amount}} Creatics Currency<br><br> 
            Your balance is : {{currency}}

            <!-- Amount Deducted On Purchase 10% of {{data.amount}} : {{data.totalAmt}} -->
        </p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn" (click)="dialogRef.close()" *ngIf="!disable">Cancel</button>

        <button type="button" class="btn" (click)="dialogRef.close()" *ngIf="disable">Cancel</button>
        <button type="button" class="btn creatics"
            (click)="creaticsCurrency(data.badgeId,data.amount,data.id, data.name); dialogRef.close()" *ngIf="disable">
            Pay {{data.amount}} Currency
        </button>
    </div>
</ng-template>

<!-- ------------------popup for ecosystem badge------------------------------ -->
<ng-template #ecodialogTemplate let-dialogRef="dialogRef" let-data>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Buy {{data.name}} badge</h4>
    </div>
    <div style="justify-content: flex-end;" fxLayout="row">
        <button type="button" class="close-icon" aria-label="Close" (click)="dialogRef.close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <br>
    <div class="custom-dialog-container" fxLayout="row">
        <img src="{{ data.image }}" class="badge popup-img" alt="badge">
        <p class="data">Pay {{data.totalAmt}} through Creatics Currency or pay ${{stripeAmount}} through debit/credit card.</p>
        <p class="data">Available Creatics Currency : {{currency}}</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn" (click)="dialogRef.close()">Cancel</button>
        <button type="button" class="btn creatics"
            (click)="creaticsCurrencyEco(data.badgeId,data.totalAmt,data.id, data.name); dialogRef.close()"
            [disabled]="!ecoBadgepopup">Pay {{data.totalAmt}}
            Currency</button>
        <button type="button" class="btn card"
            (click)="paymentHandler(data.badgeId,stripeAmount,data.id, data.name,data.image)">
            Pay ${{stripeAmount}} with
            Card</button>
    </div>
</ng-template>